import axios from "axios";
import { DESIGNERS_LICENS_URL } from "../../../API/Api";

const GetSingleLicens = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "GET",
        baseURL: `${DESIGNERS_LICENS_URL}/${id}`,
        headers,
    });
    console.log(response.data);
    return response.data;
};

const UpdateSingleLicens = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "PUT",
        baseURL: `${DESIGNERS_LICENS_URL}/update/${data.id}`,
        headers,
        data: { ...data },
    });
    console.log(response.data);
    return response.data;
};
const CreateLicens = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    console.log(data);

    let response = await axios({
        method: "POST",
        baseURL: `${DESIGNERS_LICENS_URL}/create`,
        headers,
        data: { ...data },
    });
    console.log(response.data);
    return response.data;
};

const DeleteSingleLicens = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "DELETE",
        baseURL: `${DESIGNERS_LICENS_URL}/delete/${id}`,
        headers,
    });
    console.log(response.data);
    return response.data;
};

const licensService = {
    GetSingleLicens,
    DeleteSingleLicens,
    UpdateSingleLicens,
    CreateLicens,
};

export default licensService;
